// BESC
export const DEFAULT_INPUT_CURRENCY = 'VSG'
// BUSD
export const DEFAULT_OUTPUT_CURRENCY = '0x5FD55A1B9FC24967C4dB09C513C3BA0DFa7FF687'
